import { z } from "zod";
import { uppercaseUlidSchema } from "./billing";
const timestampSchema = z.number().int().min(0).max(Number.MAX_SAFE_INTEGER);
const safeAccountRowIdSchema = z
    .string()
    .trim()
    .min(1)
    .max(128)
    .regex(/^[A-Za-z0-9._:-]+$/);
export const linkableAccountProviderSchema = z.literal("google");
export const accountLinkAttemptStatusSchema = z.enum([
    "pending",
    "confirmed",
    "rejected",
    "manual_support_required",
    "expired",
]);
export const linkedProviderKindSchema = z.enum(["password", "oauth"]);
export const accountLinkSupportEscalationSchema = z.strictObject({
    category: z.literal("account_access"),
    attemptId: uppercaseUlidSchema,
    subject: z.literal("Provider linking manual review"),
    messageTemplate: z.string().min(1).max(500),
});
export const accountLinkWarningsSchema = z.strictObject({
    learningHistoryDoesNotTransfer: z.boolean(),
    billingValueDoesNotTransfer: z.boolean(),
});
export const linkedProviderSummarySchema = z.strictObject({
    accountRowId: safeAccountRowIdSchema,
    provider: z.string().min(1).max(64),
    label: z.string().min(1).max(80),
    kind: linkedProviderKindSchema,
    linkedAt: timestampSchema.nullable(),
    canUnlink: z.boolean(),
    lastUsableMethod: z.boolean(),
});
export const linkableProviderSummarySchema = z.strictObject({
    provider: linkableAccountProviderSchema,
    label: z.literal("Google"),
});
export const activeAccountLinkAttemptSchema = z.strictObject({
    attemptId: uppercaseUlidSchema,
    provider: linkableAccountProviderSchema,
    status: accountLinkAttemptStatusSchema,
    expiresAt: timestampSchema,
});
export const linkedProviderListResponseSchema = z.strictObject({
    providers: z.array(linkedProviderSummarySchema).max(20),
    linkableProviders: z.array(linkableProviderSummarySchema).max(1),
    activeAttempt: activeAccountLinkAttemptSchema.nullable(),
});
export const accountLinkStartInputSchema = z.strictObject({
    provider: linkableAccountProviderSchema,
});
export const accountLinkStartResponseSchema = z.strictObject({
    attemptId: uppercaseUlidSchema,
    provider: linkableAccountProviderSchema,
    status: z.literal("pending"),
    authorizationUrl: z.url().optional(),
    expiresAt: timestampSchema,
    warnings: accountLinkWarningsSchema,
});
export const accountLinkStatusQuerySchema = z.strictObject({
    attemptId: uppercaseUlidSchema,
    error: z.string().trim().min(1).max(128).optional(),
});
export const accountLinkStatusResponseSchema = z.strictObject({
    attemptId: uppercaseUlidSchema,
    provider: linkableAccountProviderSchema,
    status: accountLinkAttemptStatusSchema,
    expiresAt: timestampSchema,
    completedAt: timestampSchema.nullable(),
    warnings: accountLinkWarningsSchema,
    supportEscalation: accountLinkSupportEscalationSchema.optional(),
});
export const accountLinkUnlinkInputSchema = z.strictObject({
    accountRowId: safeAccountRowIdSchema,
});
export const accountLinkUnlinkResponseSchema = z.strictObject({
    removed: z.literal(true),
    providers: z.array(linkedProviderSummarySchema).max(20),
});
//# sourceMappingURL=account.js.map